import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { OdataResponse } from '@pec/aion-ui-odata/types/odataResponse';

const name = 'trainingCompliance';

enum TrainingComplianceStatus {
  NonCompliant = 'NonCompliant'
}

type TrainingComplianceItem = {
  contractorId: string;
  status: number;
  isDeleted: boolean;
};

export const fetchTrainingComplianceCount = createAsyncThunk(
  `${name}/fetchCount`,
  async (organizationId: string, { dispatch }) => {
    try {
      const params = {
        $filter: `contractorId eq ${organizationId} and status eq '${TrainingComplianceStatus.NonCompliant}' and isDeleted eq false`
      };

      const { data } = await axios.get<OdataResponse<TrainingComplianceItem[]>>(
        '/api/trainingCompliance/v3.01/employeeTrainingRequirements',
        { params }
      );

      return data['@odata.count'] ?? data.value.length ?? 0;
    } catch (err) {
      dispatch(enqueueRequestErrorSnackbar());
      throw err;
    }
  }
);

export type State = CommonState & {
  count: number | null;
};

const initialState: State = {
  count: null,
  isFetching: false,
  error: null
};

const trainingCompliance = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTrainingComplianceCount.pending, isFetching)
      .addCase(fetchTrainingComplianceCount.fulfilled, (state, action) => {
        state.count = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchTrainingComplianceCount.rejected, error);
  }
});

export const { reducer: trainingComplianceReducer } = trainingCompliance;
